import classNames from 'classnames';
import React, { useState } from 'react';

import './BannerDecoupled.scss';

const swapCookiesToMonolith = () => {
  document.cookie =
    'wt_frontend_decoupled=never; Domain=.wetransferbeta.com; Path=/; Expires=7200; Max-Age=7200;';
  document.cookie =
    'wt_frontend_monolith=always; Domain=.wetransferbeta.com; Path=/; Expires=7200; Max-Age=7200;';

  window.location.reload();
};

const BannerDecoupled = (): JSX.Element => {
  const [isDismissed, setDismissed] = useState(false);

  const dismissBanner = () => {
    setDismissed(true);
  };

  return (
    <div
      className={classNames('Banner-wrapper-decoupled', {
        'Banner-wrapper-decoupled__dismissed': isDismissed,
      })}
    >
      <div
        className="Banner-decoupled__text-content"
        onClick={swapCookiesToMonolith}
      >
        Powered by Decoupled Project <br />
        Click to swap to monolith
      </div>
      <div className="Banner-decoupled__dismiss" onClick={dismissBanner}>
        X
      </div>
    </div>
  );
};

export default BannerDecoupled;
